import React, { useState, useEffect, useRef } from 'react';
import { useSnackbar } from 'notistack';
import {
  Box,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Divider,
  Button,
  Typography,
  CircularProgress,
  TextField,
} from '@mui/material';
import { getYears } from '../../utils/constCodeUtils';
import * as xlsx from 'xlsx';
import {
  makeAccountSalesData,
  makeAccountSalesHeader,
} from '../../utils/eis-statics-data';

import * as salesCostsApi from '../../lib/api/salesCosts';

import AccountSalesMangageStaticTable from '../../components/account-sales-manage-statics/AccountSalesMangageStaticTable';
import { useDispatch, useSelector } from 'react-redux';
import { getCompanies } from '../../modules/auth';

const AccountSalesManageStaticsContainer = () => {
  const tableRef = useRef();

  const dispatch = useDispatch();
  const { companies } = useSelector(({ auth }) => ({
    companies: auth.companies,
  }));
  const [companyCd, setCompanyCd] = useState('ALL');
  const [years, setYears] = useState(null);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [headerRows, setHeaderRows] = useState(null);

  useEffect(() => {
    const arrYears = getYears(3, 1);
    setYears(arrYears);
  }, []);

  const handleChangeYear = (event) => {
    setSelectedYear(event.target.value);
  };

  const handleCompany = (event) => {
    setCompanyCd(event.target.value);
  };

  const handleDownExcel = () => {
    const el = tableRef;
    const name = '계정별 판매관리비 통계';
    htmlToExcel(el.current, name);
  };

  const htmlToExcel = (tableEl, name) => {
    const wb = xlsx.utils.table_to_book(tableEl, {
      sheet: 'sheet1',
      raw: true,
    });
    xlsx.writeFile(wb, name + '.xlsx');
  };

  useEffect(() => {
    if (!companies || companies.length === 0) {
      dispatch(getCompanies());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, companies]);

  useEffect(() => {
    if (selectedYear && companies) {
      const headers = makeAccountSalesHeader();
      setHeaderRows(headers);
      //const tempData = makeAccountSalesData(companies);
      //console.log(JSON.stringify(tempData));

       const response = salesCostsApi.getSalesCostsStaticTotal(selectedYear);      

        setData(response.data);
    }
  }, [companies, selectedYear]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', my: 2 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Box sx={{ mx: 1, minWidth: 120 }}>
            <TextField
              variant="standard"
              fullWidth
              select
              label="회사"
              name="company"
              value={companyCd}
              onChange={handleCompany}
            >
              <MenuItem value="ALL">전체</MenuItem>
              {companies &&
                companies.map((option) => (
                  <MenuItem key={option.companyCd} value={option.companyCd}>
                    {option.companyNm}
                  </MenuItem>
                ))}
            </TextField>
          </Box>
          <Box sx={{ mr: 1, minWidth: 120 }}>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="selected-year-label">기준년도</InputLabel>
              <Select
                labelId="selected-year-label"
                id="selected-year"
                value={selectedYear}
                label="년도"
                onChange={handleChangeYear}
              >
                {years &&
                  years.map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Box>
            <Button
              variant="contained"
              color="success"
              onClick={handleDownExcel}
            >
              엑셀 다운로드
            </Button>
          </Box>
        </Box>
      </Box>
      <Divider sx={{ my: 1 }} />

      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        {loading ? (
          <Box sx={{ display: 'flex' }}>
            <CircularProgress />
          </Box>
        ) : Array.isArray(data) && data.length === 0 ? (
          <Box>
            <Typography variant="subtitle2">데이터가 없습니다.</Typography>
          </Box>
        ) : (
          <AccountSalesMangageStaticTable
            data={data}
            loading={loading}
            headerRows={headerRows}
            tableRef={tableRef}
          />
        )}
      </Box>
    </Box>
  );
};
export default AccountSalesManageStaticsContainer;
